import CustomTable from "../../../../components/table/CustomTable";
import AccessLogsTableApp from "../Functionality/AccessLogsTableApp";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AccessLogsTab = ({finalArray, modified, setModified}) => {
 // Destructure table configuration and pagination
    const {
        tableId,
        thead,
        tbody,
        getActionsButtons,
        pagination
    } = AccessLogsTableApp({
        finalArray,
        modified,
        setModified
    });

    return (
        <>
            <CustomTable tableId={tableId}
                         thead={thead}
                         tbody={tbody}
                         columnActions={false}
                         getActionsButtons={getActionsButtons}
            />
            { pagination() }
        </>
    );
};

export default AccessLogsTab;
